import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  background-color: #ffffff;
  border: 1px solid #d5d5d5;
  border-radius: 8px;
  padding: 15vh;
  margin-bottom: 10px;
  align-items: center;
  justify-content: center;
  /* elevation: 2; */
`;

export const Text = styled.p`
  font-size: 16px;
  font-family: Inter;
  color: #333333;
`;
